import React, { useState } from "react";

const CorrectPiece = () => {
    const [form, setForm] = useState({
        piece: "",
        reason: "",
        status: "Terminée",
        assignedTo: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Correction mise à jour :", form);
        setForm({ piece: "", reason: "", status: "Terminée", assignedTo: "" });
    };

    return (
        <div className="max-w-4xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-4">Corriger une pièce</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block mb-2 font-semibold">Pièce :</label>
                    <input
                        type="text"
                        name="piece"
                        value={form.piece}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Raison :</label>
                    <textarea
                        name="reason"
                        value={form.reason}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                    />
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Statut :</label>
                    <select
                        name="status"
                        value={form.status}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                    >
                        <option value="Terminée">Terminée</option>
                        <option value="En attente">En attente</option>
                        <option value="En cours">En cours</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-2 font-semibold">Assigné à :</label>
                    <input
                        type="text"
                        name="assignedTo"
                        value={form.assignedTo}
                        onChange={handleChange}
                        className="border border-gray-300 rounded p-2 w-full"
                        required
                    />
                </div>
                <button
                    type="submit"
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                >
                    Mettre à jour la correction
                </button>
            </form>
        </div>
    );
};

export default CorrectPiece;
